<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Prices'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-row class="extra-bottom-padding">
        <form [formGroup]="addressForm">
          <tidy-filter
            [items]="addressList"
            [form]="addressForm.controls.address"
            formControlName="address"
            (optionChange)="changeProperty()"
            [initValue]="addressId"
            class="align-center" />
        </form>
      </tidy-row>
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Edit your base prices for this property below. Your base price is what you pay for a recurring job where you are charged before. Same day, one time and charge after prices are calculated automatically based on your base price.'" />
      </tidy-row>
      <tidy-card>
        <form [formGroup]="form">
          @for (service of services; track service) {
            @if (service.billing_type !== 'price_later') {
              <tidy-row>
                <tidy-input
                  [formControlName]="service.id"
                  [label]="service.name"
                  [form]="form.controls[service.id]"
                  [icon]="'assets/svg/card.svg'"
                  [errorMessage]="'Please select a price.'"
                  [submitted]="submitted"
                  inputMode="numeric"
                  [mask]="'currencyMask'" />
              </tidy-row>
            }
          }
        </form>
      </tidy-card>
      <tidy-button
        [text]="'Save Changes'"
        [action]="boundSaveChanges"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
